export default {
  handleWordResize,
  handleWordPositioner,
};

function handleWordResize(canvas: fabric.Canvas) {
  let gridWidth = 19;
  let gridHeight = 15;
  canvas.forEachObject((obj: fabric.Text) => {
    const { top, left, width, height } = handleWordPositioner(
      canvas,
      gridWidth,
      gridHeight,
      // @ts-ignore
      obj.id
    );
    obj.set({
      fontSize: window.innerWidth < 768 ? 12 : 20,
      left: left,
      width: width,
      height: height,
    });
    obj.set({
      top: top + (height - obj.height) / 2,
      width: obj.height,
      left: obj.left + (obj.width - obj.height) / 2,
    });
  });
}

function handleWordPositioner(
  canvas: fabric.Canvas,
  gridWidth: number,
  gridHeight: number,
  index: number | string,
  topOffset = 0
): {
  left: number;
  top: number;
  width: number;
  height: number;
} {
  let letterWidth = canvas.getWidth() / gridWidth;
  let letterHeight = canvas.getHeight() / gridHeight;
  let tempIndex: number;
  if (typeof index === "string") {
    tempIndex = parseInt(index);
  } else {
    tempIndex = index;
  }
  let rowPos: number = 0;
  let colPos: number = 0;
  for (let i = 0; i < gridHeight; i++) {
    if (tempIndex >= gridWidth * i && tempIndex <= gridWidth * i + gridWidth) {
      rowPos = tempIndex - gridWidth * i;
      colPos = i;
    }
  }
  return {
    left: letterWidth * rowPos,
    top: letterHeight * colPos + topOffset,
    width: letterWidth,
    height: letterHeight - topOffset,
  };
}
